import React from 'react';
import styled from 'styled-components';

const HomeContent = styled.div`
  text-align: center;
  padding: 2rem;
`;

const WelcomeTitle = styled.h1`
  color: #333;
  margin-bottom: 1rem;
`;

const WelcomeText = styled.p`
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto 2rem;
  line-height: 1.6;
`;

const QuickLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

const LinkCard = styled.a`
  display: block;
  padding: 1rem 2rem;
  background-color: #333;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #bada55;
    color: #333;
    text-decoration: none;
  }
`;

const HomePageContent = () => {
  return (
    <HomeContent>
      <WelcomeTitle>Welcome to NSE Data Portal</WelcomeTitle>
      <WelcomeText>
        Access and manage NSE (National Stock Exchange) data with our comprehensive 
        data management system. View data tables, add new entries, and visualize 
        trends through interactive charts.
      </WelcomeText>
      {/* <QuickLinks>
        <LinkCard href="/nsedetails">View NSE Data</LinkCard>
        <LinkCard href="/addnse">Add New Entry</LinkCard>
        <LinkCard href="/nsechart">View Charts</LinkCard>
      </QuickLinks> */}
    </HomeContent>
  );
};

export default HomePageContent;